import { TmrBaseResource } from 'stylewhere/api'

export class ItemEvents extends TmrBaseResource {
  static endpoint = '/api/v1/itemEvents/item' // /tracking
}
